<template>
  <div class="hello">
    <hd @updateMenu="getCurrentMenu" class="header"></hd>
    <div class="main-content">
      <div class="side-menu isMobile">
        <ul>
          <li :class="{ selected: currentMenu.label === menu.label }" v-for="menu in menus"><a style="position:relative;"
              :href="menu.url">{{ menu.label }}
              <div v-if="menu.label=='工单列表' && handleTicket!='0'" style="position:absolute;right:-8px;top:1px;background:#ff4650;width:10px;height:10px;border-radius: 50%;"></div>
              <div v-if="menu.label=='我的任务' && hasHandleExp" style="position:absolute;right:-8px;top:1px;background:#ff4650;width:10px;height:10px;border-radius: 50%;"></div>
            </a>
          </li>
        </ul>
      </div>
      <div class="content-container">
        <div>
          <h3 class="title" v-if="currentMenu.showTitle !== false">{{ currentMenu.name || currentMenu.label }}</h3>
          <div class="flex" style="justify-content: center" v-if="currentMenu.label=='账单结算'">
            <a @click="handleTab(1)">
              <h3 class="title" :class="option==2?'normal':''">账单</h3>
            </a>
            <span class="title" style="font-weight: normal">|</span>
            <a @click="handleTab(2)">
              <h3  :class="option==1?'normal':''"  class="title">结算</h3>
            </a>
          </div>
          <router-view ref="routerView" />
        </div>
      </div>
    </div>
    <mobilefooter v-if="mobiletype"></mobilefooter>
    <ft v-else class="ft"></ft>
    <GlobalDialogs></GlobalDialogs>
    <MessageDialog></MessageDialog>
  </div>
</template>

<script>
import hd from './Header'
import ft from './Footer'
import mobilefooter from './mobilefooter'
import api from '../services/api.js'
import { SIDEMENU, SINGLESIDEMENU, SHIPPINGMANAGERSIDEMENU } from '../services/constant.js'
import GlobalDialogs from './GlobalDialogs'
import MessageDialog from './MessageDialog'


export default {
  name: 'HelloWorld',
  components: {
    hd: hd,
    ft: ft,
    GlobalDialogs: GlobalDialogs,
    mobilefooter: mobilefooter,
    MessageDialog: MessageDialog
  },
  created() {
    if (document.body.clientWidth < 1024) {
      this.mobiletype = true
      this.taskInfo.mobiletype = true
      this.$store.commit('updateTaskInfo', this.taskInfo)
    }
    this.getCurrentMenu()
  },
  beforeDestroy(){
    clearInterval(this.tickethandler)
  },
  computed: {
    taskInfo() {
      return this.$store.state.taskInfo
    },
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  data() {
    return {
      screenWidth: document.body.clientWidth,
      mobiletype: false,
      menus: SIDEMENU,
      currentMenu: {},
      timer: null,
      tickethandler:-1,
      expthandler:-1,
      handleTicket:0,
      hasHandleExp:false,
      option:1,

    }
  },
  async mounted() {
    if(this.tickethandler!=-1)
      clearInterval()
    let res = await api.getTicketListCount(this,{status_id_list:["1"]})
    if(res && res.body)
      this.handleTicket=res.body.result
    this.tickethandler=setInterval(async ()=>{
      let res = await api.getTicketListCount(this,{status_id_list:["1"]})
      if(res && res.body)
        this.handleTicket=res.body.result
    },10000)

    if(this.expthandler!=-1)
      clearInterval()
    let exp_res = await api.getSingleOrdersCount(this,{order_exception_type_list:-2,order_exception_type:-2,order_exception_status:1})
    if(exp_res && exp_res.body)
      this.hasHandleExp=exp_res.body.result==0?false:true
    this.expthandler=setInterval(async ()=>{
      let res = await api.getSingleOrdersCount(this,{order_exception_type_list:-2,order_exception_type:-2,order_exception_status:1})
      if(res && res.body)
        this.hasHandleExp=res.body.result==0?false:true
    },10000)
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
      this.$forceUpdate()
    }
  },
  methods: {
      handleTab(v){
          this.option=v;
          this.$refs['routerView'].handleTab(this.option)
      },
    handleAllEditMode() {
      if (this.$route.path == '/buyer/publish_task/index')
        this.$refs.routerView.handleAllEditMode()
    },
    getCurrentMenu() {
      let name = this.$route.name
      let has_single = sessionStorage.getItem('isSingle');
      let has_shipping_manager = sessionStorage.getItem('has_shipping_manager');

      if (has_single==1 || has_shipping_manager == 1) {
        if (has_single == 1) {
          if (this.$localStorage.get('single_type') == 2) {
            this.menus = SINGLESIDEMENU.filter(i => !i.noexternal)
          }
          else {
            this.menus = SINGLESIDEMENU
          }
        }
        else if (has_shipping_manager == 1) {
          this.menus = SHIPPINGMANAGERSIDEMENU
        }
      } else {
        this.menus = SIDEMENU
      }
      for (let menu of this.menus) {
        console.log('routename',name,menu.url);
        if (menu.url.indexOf(name) > -1) {
          this.currentMenu = menu
          return
        }
      }
    }
  },
  watch: {
    $route() {
      this.getCurrentMenu()
    },
    'userInfo.has_single'(val) {
      console.log('watch')
      this.getCurrentMenu()
    },
    screenWidth(val) {
      if (!this.timer) {
        this.screenWidth = val
        if (val < 1024) {
          this.mobiletype = true
          this.taskInfo.mobiletype = true

          this.$store.commit('updateTaskInfo', this.taskInfo)
        } else {
          this.mobiletype = false
          this.taskInfo.mobiletype = false
          this.$store.commit('updateTaskInfo', this.taskInfo)
        }

        this.timer = true
        let that = this
        setTimeout(function () {
          // that.screenWidth = tha t.$store.state.canvasWidth
          that.timer = false
        }, 400)
      }
      this.$forceUpdate()
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header {
  border-bottom: 1px solid #d7d7d7;
}

.crumbs {
  margin-top: 34px;
  max-width: 1200px;
  margin: 34px auto 10px;
}

.main-content {
  padding-top: 144px;

  .select-shop {
    max-width: 760px;
    margin: 0 auto;
  }

  .publish-task-product {
    max-width: 1140px;
    margin: 0 auto;
  }

  .side-menu {
    padding-top: 80px;
    width: 243px;
    float: left;

    ul {
      padding-left: 90px;

      .selected {
        font-weight: bold;
        color: #333;
      }

      a {
        color: #666;
        line-height: 35px;
      }
    }
  }

  .content-container {
    padding-top: 44px;
    margin-left: 243px;
    padding-right: 243px;
    width: 100%;
    border-left: 1px solid #D7D7D7;
    min-height: 65vh;

    &>div {
      padding: 0 65px 0 30px;
    }

    .title {
      height: 20px;
      font-size: 18px;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      text-align: center;
      margin-bottom: 35px;
      font-weight: bold;
    }
  }
}

@media screen and (max-width:1024px) {

  .main-content {
    padding-top: 51px;

    .isMobile {
      display: none !important;
    }

    .content-container {
      margin-left: 0px;
      padding-right: 0px;
      padding-top: 20px;
      min-height: 56vh;

      &>div {
        padding: 0 10px;
      }
    }
  }
}</style>



// WEBPACK FOOTER //
// src/components/LayoutSideMenu.vue